<template>
    <ul class="rg-tab-list">
        <li v-for="item in items" :key="item.value"
            class="rg-tab-item"
            :class="{'rg-tab-item--active': local_value == item.value}"
        >
            <a href="#" @click.prevent="local_value = item.value"><h2 v-if="heading" class="rg-tab-heading">{{item.label}}</h2><template v-else>{{item.label}}</template></a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'tabs',
        emits: ['update:modelValue'],
        props: {
            items: {
                type: Array
            },
            value: {
                type: String
            },
            heading: {
                type: Boolean,
                default: false
            }
        },
        model: {
            prop: 'value',
            event: 'change'
        },
        data: function ()
        {
            return {
                local_value: this.value
            }
        },
        watch: {
            local_value: function (value)
            {
                this.$emit('change', value);
            },
            value: function (value)
            {
                this.local_value = value;
            }
        },
        mounted: function ()
        {

        }
    }
</script>

<style>
    .rg-tab-list {
        display: flex !important;
        flex-wrap: wrap !important;
        list-style: none !important;
        margin: 0 !important;
        padding: 0 !important;
        height: auto !important;
        min-height: 36px !important;
        overflow: visible !important;
        border-bottom: none !important;
        width: 100% !important;
        box-sizing: border-box !important;
    }

    .rg-tab-item {
        flex: 1 1 0% !important;
        min-width: 0 !important;
        float: none !important;
        list-style: none !important;
        cursor: pointer !important;
        position: relative !important;
        margin: 0 2px 0 0 !important;
        padding: 0 !important;
    }

    .rg-tab-item:last-child {
        margin-right: 0 !important;
    }

    .rg-tab-item a,
    .rg-tab-item a:visited {
        display: block !important;
        float: none !important;
        background: #cececd !important;
        color: #111 !important;
        text-align: center !important;
        padding: 10px 5px !important;
        font-family: "Didot 16 A", "Didot 16 B", Didot, Lyon, serif !important;
        font-size: 11px !important;
        font-weight: normal !important;
        text-transform: uppercase !important;
        text-decoration: none !important;
        white-space: nowrap !important;
        width: 100% !important;
        height: auto !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
        border-left: none !important;
    }

    @media (max-width: 991px) {
        .rg-tab-item a,
        .rg-tab-item a:visited {
            white-space: normal !important;
            font-size: 10px !important;
            padding: 8px 4px !important;
        }
    }

    @media (max-width: 575px) {
        .rg-tab-list {
            gap: 2px !important;
        }

        .rg-tab-item {
            flex: 1 1 calc(50% - 2px) !important;
            margin: 0 !important;
        }

        .rg-tab-item:last-child {
            margin: 0 !important;
        }

        .rg-tab-item a,
        .rg-tab-item a:visited {
            white-space: normal !important;
            font-size: 10px !important;
            padding: 10px 6px !important;
        }

        .rg-tab-item--active::after {
            display: none !important;
        }
    }

    .rg-tab-item--active > a,
    .rg-tab-item--active > a:visited,
    .rg-tab-item > a:hover,
    .rg-tab-item > a:focus,
    .rg-tab-item > a:active {
        background: #111111 !important;
        color: #ffffff !important;
    }

    .rg-tab-item--active {
        position: relative !important;
    }

    .rg-tab-item--active::after {
        content: '' !important;
        position: absolute !important;
        bottom: -12px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        width: 0 !important;
        height: 0 !important;
        border-left: 8px solid transparent !important;
        border-right: 8px solid transparent !important;
        border-top: 12px solid #111111 !important;
        z-index: 2 !important;
    }
</style>
